import {
  Icon,
  TextInput,
  useCallbackRef,
  useNavigationContext,
} from '@infotech-soe/erp-ui-kit';
import { OnClearHandler } from '@infotech-soe/erp-ui-kit/dist/utils/useClearButton';
import React, { memo, MouseEvent, useCallback, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';

import { useMenuContext } from './MenuContext';
import { searchBarMessages } from './messages';

const SEARCHBAR_NAME = 'serach-bar';

const SearchBar = (): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const searchBarRef = useRef<HTMLInputElement>(null);

  const { collapsed, query, onFilterMenu, onSubmitSearchQuery } =
    useMenuContext();
  const { active, onActivate, onRegister } = useNavigationContext();

  const callbackRef = useCallbackRef(searchBarRef, (el: HTMLInputElement) =>
    onRegister(el, SEARCHBAR_NAME, collapsed)
  );

  const handleClear = useCallback<OnClearHandler>(
    e => {
      e.stopPropagation();
      onFilterMenu('');
    },
    [onFilterMenu]
  );

  const handleClick = useCallback(
    (e: MouseEvent<HTMLInputElement>) => {
      e.stopPropagation();
      onActivate(e, SEARCHBAR_NAME);
    },
    [onActivate]
  );

  useEffect(() => {
    if (!collapsed) {
      setTimeout(() => searchBarRef.current?.focus(), 300);
      onActivate({} as MouseEvent<HTMLElement>, SEARCHBAR_NAME);
    }
    if (collapsed && query) onFilterMenu('');
  }, [query, collapsed, onActivate, onFilterMenu]);

  return (
    <TextInput
      className="row no-wrap items-center m-px-sm overflow-hidden"
      placeholder={formatMessage(searchBarMessages.search)}
      ref={callbackRef}
      startSlot={<Icon name="search" size={16} />}
      tabIndex={active === SEARCHBAR_NAME ? 0 : -1}
      value={query}
      onChange={onFilterMenu}
      onClear={handleClear}
      onClick={handleClick}
      onSubmit={onSubmitSearchQuery}
    />
  );
};

export default memo(SearchBar);
